var navigator_platform,windowWidth,lazyImages,lazyBackground,lazyIframe,lazyScripts,src,style,datasrc,urls,analytics,s,x,i,j,flag;
document.addEventListener("DOMContentLoaded", function() {
	navigator_platform = navigator.platform;
	windowWidth = screen.width;
	lazyImages = document.querySelectorAll('img.lazy2');
	nolazyImages = document.querySelectorAll('img.lazy');
	lazyBackground = document.querySelectorAll('.lazybg');
	lazyIframe = document.querySelectorAll('iframe');
	lazyScripts = document.getElementsByTagName("script");
	i=0;
	j=0;
	flag=1;

//	lazyLoadImg2();

	if(navigator_platform != "Linux x86_64") {
		init();
	}

	window.addEventListener("scroll", function() {
		init();
	});
	window.addEventListener("mousemove", function() {
		init();
	});
	window.addEventListener("touchstart", function() {
		init();
	});
	setTimeout(function() {
		init();
	}, 6000);
});
function init() {
	if(flag) {
		flag=0;
		lazyLoadImg();
		lazyLoadBackground();
		lazyLoadIframe();
		load_all_js();
	}
}
function isElementInViewport (el) {
	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}
function lazyLoadImg() {
	lazyImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
		else
			src = elem.dataset.src;

		if( src != null )
			elem.src = src;

		elem.classList.remove("lazy2");
	});
}
function lazyLoadImg2() {
	lazyImages.forEach(function(elem) {
		if( isElementInViewport(elem) ) {
			if( windowWidth < 600 )
				src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
			else
				src = elem.dataset.src;

			if( src != null )
				elem.src = src;

			elem.classList.remove("lazy");
		}
	});
}
function lazyLoadBackground() {
	lazyBackground.forEach(function(elem) {
		if( windowWidth < 600 )
			lazybg = (elem.dataset.mobstyle == undefined) ? elem.dataset.style : elem.dataset.mobstyle;
		else
			lazybg = elem.dataset.style;

		if( lazybg != null )
			elem.style = lazybg;

		elem.classList.remove("lazybg");
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(function(elem) {
		elem.src = (elem.dataset.src == undefined) ? elem.src : elem.dataset.src;
	});
}
function lazyLoadScripts() {
	if (j == lazyScripts.length)
		return;

	if ( lazyScripts[j].getAttribute("type") == "lazyload2" ) {
		lazyScripts[j].setAttribute("type", "lazyloaded");
		if (typeof lazyScripts[j].dataset.src !== 'undefined') {
			s=document.createElement("script");
			s.src=lazyScripts[j].dataset.src;
			document.body.appendChild(s);
			s.onload=function() {
				j++;
				lazyLoadScripts();
			};
		} else {
			s=document.createElement("script");
			s.innerHTML=lazyScripts[j].innerHTML;
			document.body.appendChild(s);
			j++;
			lazyLoadScripts();
		}
	} else {
		j++;
		lazyLoadScripts();
	}
}
function lazyLoadCss(url) {
	s=document.createElement("link");
	s.rel="stylesheet";
	s.href=url;
	document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadJS(url) {
	s=document.createElement("script");
	s.src=url;
	document.body.appendChild(s);
}
function load_all_js() {
	lazyLoadCss("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
	lazyLoadCss("//cdn.shopify.com/s/files/1/1213/0400/t/60/assets/appmate-wishlist-king.scss.css?v=43836656340830028021643009738");
	lazyLoadCss("//cdn.shopify.com/s/files/1/1213/0400/t/60/assets/wnw-style.css?v=117436290196806945931643009738");

	
		setTimeout(function() {
			const wnw_load = new Event('wnw_load');
			window.dispatchEvent(wnw_load);
		}, 100);
	

	lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/load_feature-24ff1222c9aa13bb217653c0d3ea28c40a796a280e6da29ad421eec2a6075c86.js");
	lazyLoadJS("https://cdn.shopify.com/s/assets/shopify_pay/storefront-21b5dddfc8b64c1ad68cee3ba7448d1ffa15c24e969ebc1fbccf1a3784b659ad.js");
	lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/features-87e8399988880142f2c62771b9d8f2ff6c290b3ff745dd426eb0dfe0db9d1dae.js");
	lazyLoadJS("https://cdn.shopify.com/s/assets/themes_support/ga_urchin_forms-99e991855b3d8ddc69e625c68ab0579dd9927b611c2ec4943d396c72e3af0849.js");

	j=0;
	lazyScripts = document.getElementsByTagName("script");
	lazyLoadScripts();

	setInterval(function() {
		lazyImages = document.querySelectorAll('img.lazy2');
		lazyBackground = document.querySelectorAll('.lazybg');
		lazyLoadImg();
		lazyLoadBackground();
	}, 3000);

	
}